import { call, put, select } from 'redux-saga/effects'
import { push } from 'connected-react-router'

import AuthActions from 'store/redux/auth'
import McActions from 'store/redux/mc'
import RouterDataActions from 'store/redux/routerData'
import GlobalActions from 'store/redux/global'
import { UserSession } from 'utils/session'
import Socket from 'api'
import ERROR from 'utils/errors'

export function* signin({ data }) {
    const { type, code, username, password } = data
    yield put(GlobalActions.showLoading())
    yield put(AuthActions.setPlayer({ username }))
    yield put(AuthActions.setType(type))
    Socket.create(type, { uuid: code, username, password })
}

export function* handleAuthenticated() {
    const { type, reconnecting } = yield select(state => state.auth)
    if (reconnecting) {
        if (type === 'player') {
            Socket.emitters().status.requestCurrentStatus()
            yield put(AuthActions.setReconnecting(false))
        } else if (type === 'admin') {
            const { game } = yield select(state => state.mc)
            if ((game || {}).gameCode) {
                yield put(McActions.requestGameData({ gameCode: game.gameCode }))
            } else {
                yield put(AuthActions.setReconnecting(false))
            }
            yield put(GlobalActions.hideLoading())
        } else {
            // type === 'superadmin'
            yield put(AuthActions.setReconnecting(false))
            yield put(GlobalActions.hideLoading())
        }
    } else {
        Socket.emitters().auth.getMyUser()
        yield put(AuthActions.setReconnecting(false))
    }
}

export function* handleUserData({ response }) {
    const { ok, problem, data } = response
    if (ok) {
        const { type, uuid, name: nameFromServer, nickname: nicknameFromServer, username } = data || {}
        if (type === 'player') {
            const { username: storedName } = yield select(state => state.auth.player)
            yield* setAuthData({ uuid, type, username: storedName || nameFromServer, nickname: nicknameFromServer })
            if (!nicknameFromServer) {
                yield put(GlobalActions.hideLoading())
                yield put(push('/onboarding'))
            } else {
                if (storedName && storedName !== nameFromServer) {
                    Socket.emitters().player.updatePlayer({ name: storedName })
                }
                Socket.emitters().status.requestCurrentStatus()
            }
        } else if (type === 'admin') {
            yield* setAuthData({ uuid, type, username })
            yield put(GlobalActions.hideLoading())
            yield put(push('/mc'))
        } else if (type === 'superadmin') {
            yield* setAuthData({ uuid, type, username })
            yield put(GlobalActions.hideLoading())
            yield put(push('/admin'))
        }
    } else {
        yield put(GlobalActions.hideLoading())
        yield put(GlobalActions.error(ERROR.UNKNOWN))
    }
}

function* setAuthData({ uuid, type, username, nickname }) {
    yield call(UserSession.set, uuid)
    yield put(AuthActions.setUuid(uuid))
    yield put(AuthActions.setType(type))
    yield put(AuthActions.setPlayer({ username: username || undefined, nickname: nickname || undefined }))
}

export function* setNickname({ nickname }) {
    // console.log('setNickname')
    yield put(GlobalActions.showLoading())
    const { username } = yield select(state => state.auth.player)
    Socket.emitters().player.updatePlayer({ name: username, nickname })
}

export function* handlePlayerUpdated({ response }) {
    const { ok, problem, data } = response
    // console.log('handlePlayerUpdated', data)
    if (ok) {
        const { uuid, type, name: username, nickname } = data || {}
        yield* setAuthData({ uuid, type, username, nickname })
        Socket.emitters().status.requestCurrentStatus()
    } else if (problem === 'nickname_already_exists') {
        yield put(GlobalActions.hideLoading())
        yield put(GlobalActions.error(ERROR.NICK_COLLISION))
    } else {
        yield put(GlobalActions.hideLoading())
        yield put(GlobalActions.error(ERROR.UNKNOWN))
    }
}

export function* handleUnauthorized() {
    const { type } = yield select(state => state.auth)
    if (type === 'admin') {
        yield put(GlobalActions.error(ERROR.MC_UNAUTHORIZED))
    } else {
        yield put(GlobalActions.error(ERROR.UNAUTHORIZED))
    }
    yield* signout()
}

export function* signout({ withRedirection = true } = {}) {
    yield put(GlobalActions.showLoading())
    const { type } = yield select(state => state.auth)
    yield put(AuthActions.setTryReconnection(false))
    Socket.disconnect()
    yield put(AuthActions.clean())
    yield put(McActions.clean())
    yield call(UserSession.unset)
    yield put(RouterDataActions.clean())
    if (withRedirection) {
        if (type === 'superadmin') {
            yield put(push('/admin/signin'))
        } else if (type === 'admin') {
            yield put(push('/mc/signin'))
        } else {
            yield put(push('/new-game'))
        }
    }
    yield put(GlobalActions.hideLoading())
}

export function* tryReconnect() {
    console.tron.log('tryReconnect')
    const { location } = yield select(state => state.router)
    if (location.pathname !== '/test1234') {
        const { type, uuid, tryReconnection, numberOfReconnectionTrials } = yield select(state => state.auth)
        // console.tron.log(type)
        // console.tron.log(uuid)
        // console.tron.log(tryReconnection)
        // console.tron.log(numberOfReconnectionTrials)
        if (type && uuid && tryReconnection && numberOfReconnectionTrials < 5) {
            console.tron.log('reconnecting')
            yield put(GlobalActions.showLoading())
            yield put(AuthActions.setNumberOfReconnectionTrials(numberOfReconnectionTrials + 1))
            yield put(AuthActions.setReconnecting(true))
            Socket.create(type, { uuid })
        } else {
            yield* signout({ withRedirection: false })
        }
    } else {
        yield* signout({ withRedirection: false })
    }
}



// WEBPACK FOOTER //
// src/store/sagas/auth.js